import { render, staticRenderFns } from "./ProfileVlan.vue?vue&type=template&id=d2d96810&"
import script from "./ProfileVlan.vue?vue&type=script&lang=js&"
export * from "./ProfileVlan.vue?vue&type=script&lang=js&"
import style0 from "./ProfileVlan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports